﻿import { createSlice } from "@reduxjs/toolkit";

const rememberMeSlice = createSlice({
  name: "rememberMe",
  initialState: {
    userName: null,
  },
  reducers: {
    setRememberMe: (state, action) => {
      const { userName } = action.payload;
      state.userName = userName;
    },
  },
});

export const { setRememberMe } = rememberMeSlice.actions;
export const selectRememberedUserName = (state) =>
  state.localInfo.rememberMe.userName;
export default rememberMeSlice.reducer;
